<script>

import consumer from '../../../utils/consumer'
import CheckoutInfo from '../../checkout-info/checkout-info'
import PreCheckoutInfo from '../../pre-checkout-info/pre-checkout-info'
import DecryptedPaymentInfo from '../../decrypted-payment-info/decrypted-payment-info'
import { EventBus } from '../../../event-bus'
import { mapGetters } from 'vuex'

export default {
  name: 'Callback',
  components: {
    CheckoutInfo,
    PreCheckoutInfo,
    DecryptedPaymentInfo
  },

  data () {
    return {
      checkoutData: {},
      checkoutResponse: {},
      initiatorAndDpaIds: {},
      payloadResponse: {},
      showCallback: false
    }
  },

  computed: {
    ...mapGetters(['decryptedPayload', 'srcNetwork', 'shippingAddress', 'srcCorrelationId', 'srcTransactionId'])
  },

  created () {
    if (consumer.getDecryptedData()) {
      this.getLastCheckoutData()
      this.showCallback = true
    }
  },

  mounted () {
    EventBus.$on('callback', () => {
      this.getLastCheckoutData()
      this.$forceUpdate()
    })
  },

  beforeDestroy () {
    this.$store.commit('updateEnableConfirmation', false)
  },

  methods: {

    /**
     * common function to get pre checkout and payload data
     */
    getLastCheckoutData () {
      let lastCheckoutData = JSON.parse(localStorage.getItem('lastCheckoutData') || {})
      this.checkoutData = lastCheckoutData['checkoutResponse']
      this.checkoutResponse = this.checkoutData['checkoutResponse']
      this.initiatorAndDpaIds = lastCheckoutData['initiatorAndDpaIds']
      this.payloadResponse = this.getDecryptedData()
    },

    /**
     * get decrypted payload data
     * @returns {*|{maskedConsumer: (*|{srcConsumerId: string, maskedConsumerMobileNumber: (*|{phoneNumber: (*|string), countryCode: *}), countryCode: string, maskedEmailAddress: *, maskedFirstName: *, maskedLastName: *}), encryptedPayload: string, shippingCountryCode: *, maskedCard: (*|{tokenLastFour: string, panBin: string, dcf: (*|{name: string, logoUri: string, type: string, uri: string}), dateOfCardLastUsed: string, countryCode: string, panLastFour: *, digitalCardData: (*|{presentationName: string, artWidth: number, artUri: string, descriptorName: string, artHeight: number, status: string}), panExpirationYear: *, srcDigitalCardId: string, tokenBin: string, billingAddress: (*|{zip: string, city: string, countryCode: string, state: string, line2: string, line1: (*|string)}), dateOfCardCreated: string, digitalCardStatus: string, panExpirationMonth: *}), shippingAddressZip: *, srcDigitalCardId: string, shippingAddressId: string, srcCorrelationId: string}}
     */
    getDecryptedData () {
      const decryptedData = consumer.getDecryptedData()
      return consumer.getPayloadResponse(decryptedData)
    },

    /**
     * Verify checkout data based on index
     * @returns string
     */
    verifyCheckoutData () {
      return this.checkoutData.idToken || this.checkoutData.checkoutResponseSignature || this.checkoutData.checkoutResponse
    }
  }

}
</script>

<template>
  <div
    id="configuration-callback"
    :class="{'set-config-height':!showCallback}"
  >
    <div v-if="showCallback">
      <div class="card mb-4">
        <h5
          aria-controls="precheckout"
          aria-expanded="false"
          class="card-header collapsed cursor-pointer"
          data-target="#precheckout"
          data-toggle="collapse"
        >
          <span class="font-weight-bold">{{ $t('label.precheckout') }}</span>
          <span class="collapsible-arrow pull-right cursor-pointer" />
        </h5>
        <div
          id="precheckout"
          class="card-body collapse show"
          role="tabpanel"
        >
          <p>
            <span>{{ $t('label.srciTransactionId') }} :</span>
            <span>{{ checkoutResponse['srciTransactionId'] || srcTransactionId }}</span>
          </p>
          <pre-checkout-info
            :pre-checkout-data="initiatorAndDpaIds"
          />
        </div>
      </div>

      <div class="card mb-4">
        <h5
          aria-controls="checkout"
          aria-expanded="false"
          class="card-header collapsed cursor-pointer"
          data-target="#checkout"
          data-toggle="collapse"
        >
          <span class="font-weight-bold">{{ $t('label.checkout') }}</span>
          <span class="collapsible-arrow pull-right cursor-pointer" />
        </h5>
        <div
          id="checkout"
          class="card-body collapse show"
          role="tabpanel"
        >
          <checkout-info
            :checkout-data="checkoutData || {}"
            :src-correlation-id="checkoutResponse.srcCorrelationId || srcCorrelationId"
          />
        </div>
      </div>

      <div
        v-if="verifyCheckoutData()"
        class="card mb-4"
      >
        <h5
          aria-controls="encryptedPaymentData"
          aria-expanded="false"
          class="card-header collapsed cursor-pointer"
          data-target="#encryptedPaymentData"
          data-toggle="collapse"
        >
          <span class="font-weight-bold">{{ $t('label.encryptedPaymentData') }}</span>
          <span class="collapsible-arrow pull-right cursor-pointer" />
        </h5>
        <div
          id="encryptedPaymentData"
          class="collapse card-body"
          role="tabpanel"
        >
          <span class="font-weight-bold">{{ $t('label.idToken') }} :</span>
          <span class="wrap-text">{{ verifyCheckoutData() }}</span>
        </div>
      </div>

      <div class="card">
        <h5
          aria-controls="decryptedPaymentData"
          aria-expanded="true"
          class="card-header collapsed cursor-pointer font-weight-bold"
          data-target="#decryptedPaymentData"
          data-toggle="collapse"
        >
          {{ $t('label.decryptedPaymentData') }}
          <span class="collapsible-arrow pull-right cursor-pointer" />
        </h5>
        <div
          id="decryptedPaymentData"
          class="card-body collapse show"
          role="tabpanel"
        >
          <decrypted-payment-info
            :decrypted-payload="decryptedPayload"
            :shipping-address="shippingAddress"
          />
        </div>
      </div>
    </div>
  </div>
</template>
